import { FC, MouseEventHandler, PropsWithChildren, ReactNode } from 'react'
import { ButtonProps, Text } from '@blueprintjs/core'
import cn from 'classnames'

type TProps = {
  className?: string
  onClick?: MouseEventHandler
  icon?: ReactNode
} & Pick<ButtonProps, 'type' | 'disabled'> &
  PropsWithChildren

const Button: FC<TProps> = ({ onClick, children, className = 'h-10 px-8 font-body---14px', icon, ...props }) => {
  return (
    <button
      className={cn(
        'flex cursor-pointer items-center justify-center rounded-lg border-none bg-palette-blue outline-hidden gap-2',
        className,
      )}
      type="button"
      onClick={onClick}
      {...props}
    >
      {!!icon && <div className="flex h-4 w-4">{icon}</div>}
      <Text tagName="span" className="flex whitespace-nowrap font-black uppercase text-palette-white">
        {children}
      </Text>
    </button>
  )
}

export { Button }
